import { useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../api/api";

const clearAuthStorage = () => {
  ["AccessToken", "RefreshToken", "CurrentAuthToken", "AuthToken", "userId", "userName", "UserInfo", "LogId"].forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
};

export default function AuthSessionGuard({ children }) {
  const location = useLocation();
  const runningRef = useRef(false);

  const forceLogout = useCallback((message) => {
    console.warn("FORCE LOGOUT TRIGGERED");

    if (message) {
      sessionStorage.setItem("sessionExpiredMessage", message);
    }

    clearAuthStorage();

    // 🔥 HARD REDIRECT (cannot be blocked)
    window.location.replace("/session-expired");
  }, []);

  const validateSession = useCallback(async () => {
  if (runningRef.current) return;
  runningRef.current = true;

  const usrId = sessionStorage.getItem("userId");
  const accessToken = sessionStorage.getItem("AccessToken");
  const currentAuthToken = sessionStorage.getItem("CurrentAuthToken");

  const publicRoutes = ["/", "/login", "/forcelogin", "/session-expired"];

  // ✅ Allow public + force-login routes
  if (publicRoutes.includes(location.pathname)) {
    runningRef.current = false;
    return;
  }

  if (!usrId || !accessToken || !currentAuthToken) {
    forceLogout();
    return;
  }

  try {
    const res = await api.AuthTokenActiveCheck({
      usrId,
      currentAuthToken,
    });

    const active =
      typeof res === "number"
        ? res
        : Number(res?.authTokenActive);

    if (active === 0) {
      forceLogout(
        "Your session has been terminated because your account is active on another device. Please sign in again."
      );
    }
  } catch (err) {
    console.error("Auth check failed", err);
    forceLogout();
  }

  runningRef.current = false;
}, [forceLogout, location.pathname]);


  // Run on route change
  useEffect(() => {
    validateSession();
  }, [validateSession]);

  // Run every 15 seconds (faster for testing)
  useEffect(() => {
    const id = setInterval(validateSession, 15000);
    return () => clearInterval(id);
  }, [validateSession]);

  return children;
}
